import { SearchResultContent } from "./SearchResultContent";

export default SearchResultContent;
